import React from 'react'
import {Card, Container, Row, Col} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const MentionsLegales = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <Container>
                <Container fluid>
                    <Row>
                        <Col lg="12">              
                            <br/>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Mentions Légales")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <h5>{t("Éditeur du site")}</h5>
                                    <p>{t("Le site www.seeks.biz est édité par la société ONYRIX SOFTWARE, société par actions simplifiée (SAS) au capital de 1 000 euros, immatriculée au Registre du Commerce et des Sociétés de Béziers sous le numéro 935 385 559.")}</p>
                                    <ul>
                                        <li>{t("Nom commercial : SEEKS.BIZ")}</li>
                                        <li>{t("Siège social : 49 Boulevard de l'Europe, 34500 Béziers – France")}</li>
                                        <li>{t("Numéro SIREN : 935 385 559")}</li>
                                        <li>{t("Numéro de TVA intracommunautaire : FR39935385559")}</li>
                                        <li>{t("Responsable de la publication : Philippe BIAU, Président")}</li>
                                        <li>{t("Adresse email de contact : contact@seeks.biz")}</li>
                                        <li>{t("Date de mise en ligne : Février 2025")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Hébergement")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Le site est hébergé par :")}</p>
                                    <p>OVH SAS<br />
                                    2 rue Kellermann, 59100 Roubaix – France<br />
                                    www.ovhcloud.com</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Objet du site")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS.BIZ est une plateforme numérique de mise en relation entre professionnels (BtoB), permettant de publier des offres de services, répondre à des demandes ciblées, et partager des documents. La plateforme agit en qualité d'intermédiaire technique et ne participe pas aux transactions commerciales entre utilisateurs.")}</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Données personnelles")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS.BIZ s'engage à respecter la règlementation RGPD. Les données personnelles collectées sont traitées de manière sécurisée, avec le consentement explicite des utilisateurs, et ne sont jamais revendues sans autorisation. Pour plus d'informations, vous pouvez consulter notre Politique de confidentialité.")}</p>
                                    <p>{t("Conformément au RGPD, les utilisateurs disposent d'un droit d'accès, de rectification, de suppression et d'opposition à leurs données. Toute demande peut être adressée à contact@seeks.biz.")}</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Propriété intellectuelle")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("L'ensemble du contenu du site (textes, images, vidéos, logo, marque, interface) est la propriété exclusive de ONYRIX SOFTWARE – SEEKS.BIZ ou de ses partenaires. Toute reproduction, représentation ou diffusion sans autorisation écrite est interdite.")}</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Modération et contributions")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Les utilisateurs peuvent publier du contenu (textes, documents, réponses). SEEKS se réserve le droit de supprimer tout contenu jugé inapproprié, non conforme à la loi ou contraire à l'éthique de la plateforme, après signalement ou contrôle interne.")}</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Responsabilité")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS.BIZ agit comme intermédiaire technique. Elle ne garantit ni la qualité des services proposés par ses utilisateurs, ni l'issue des échanges entre eux. En cas de litige, les utilisateurs doivent se tourner directement vers leurs interlocuteurs.")}</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Cookies")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Le site utilise des cookies techniques et analytiques pour améliorer l'expérience utilisateur. En continuant la navigation, l'utilisateur accepte l'usage des cookies. Voir notre Politique de cookies pour en savoir plus.")}</p>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Loi applicable")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Le présent site est soumis au droit français. En cas de litige, les tribunaux du ressort de la Cour d'appel de Paris sont seuls compétents, sauf disposition légale contraire.")}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default MentionsLegales
